import BossContainer from "./BossContainer"
import EventContainer from "./EventContainer"
import GoldContainer from "./GoldenContainer"
import InfoGeneralContainer from "./InfoGeneralContainer"
import InvasionContainer from "./InvasionContainer"
import TutorialContainer from "./TutorialContainer"

import "./Tabs.css";

import { useState } from "react"

const IndexInformation = ({}) => {

    const tabs = [
    { id: "info", label: "Info General", color: "rgba(37, 149, 177, 1)" },
    { id: "tutorials", label: "Tutoriales", color: "#5e368fff"},
    { id: "goldens", label: "Dorados", color: "rgba(134, 116, 11, 1)"},
    { id: "invasions", label: "Invasiones", color: "rgba(51, 54, 248, 1)"},
    { id: "events", label: "Eventos", color: "rgba(16, 92, 60, 1)" },
    { id: "bosses", label: "Bosses", color: "rgb(248, 51, 84)" },
  ];

  const [activeTab, setActiveTab] = useState("bosses");

  return (
    <>
    <div className="tabs-container">
      <div className="tabs">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              className={`tab ${isActive ? "active" : ""}`}
              style={{
                borderColor: isActive ? tab.color : "transparent",
                color: isActive ? tab.color : "#555",
              }}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Contenido dinámico */}
      <div className="p-4 border border-gray-200 rounded-b-md bg-white shadow-sm">
        {activeTab === "info" && <InfoGeneralContainer/>}
        {activeTab === "tutorials" && <TutorialContainer/>}
        {activeTab === "goldens" && <GoldContainer/>}
        {activeTab === "invasions" && <InvasionContainer/>}
        {activeTab === "events" && <EventContainer/>}
        {activeTab === "bosses" && <BossContainer/>}
      </div>
    </div>
        
    </>
  )

}

export default IndexInformation